module.exports = __webpack_public_path__ + "static/media/concisegray.2e87a9ec.svg";